export const API_ENDPOINT = 'https://api.kbxpvp.com';
//export const API_ENDPOINT = 'http://localhost:8081';
